export const LINE_ANALYTICS_LABELS = ['6 Days Ago', '5 Days Ago', '4 Days Ago', '3 Days Ago', '2 Days Ago', 'Yesterday', 'Today'];

export const LINE_ANALYTICS_DATA = [10, 20, 10, 50, 7, 5, 10];
